import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { DASHBOARD_ROOT } from "../../components/Routes/routingConstants";
import Loading from "../../components/Loading";
import PromptDialogs from "../../components/PromptDialog";
import React, { useState, useEffect, useRef } from "react"
import { Alert, Badge, Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from "reactstrap";
import { EmpowerMeBundle } from "../../interfaces/models/EmpowerMeBundle"
import { useEmpowerMeBundlesWithDetails, useEmpowerMeBundlesCategories } from "../../hooks/useEmpowerMe";
import { Field, Form, Formik, FormikProps } from "formik";
import TextFormInput from "../../components/Shared/Forms/TextFormInput";
import FormError from "../../components/Shared/Forms/FormError";
import { addEmpowerMeBundle, updateEmpowerMeBundle, removeEmpowerMeBundle,
 addEmpowerMeBundleCategory, updateEmpowerMeBundleCategory, removeEmpowerMeBundleCategory
} from "../../graphql/empower-me/mutations/addEmpowerMeBundle";
import { useMutation, useQuery } from "@apollo/client";
import toast from "react-hot-toast";
import { getEmpowerMeTasksActive } from "../../graphql/empower-me/EmpowerMeQueries"
import { EmpowerTask } from "../../interfaces/models/EmpowerTask";
import { EmpowerMeBundleCategory } from "../../interfaces/models/EmpowerMeBundleCategory";
import AddEmpowerMeBundleValidator from "../../validators/AddEmpowerMeBundleValidator";
import AddEmpowerMeBundleCategoryValidator from "../../validators/AddEmpowerMeBundleCategoryValidator";
import { useCategoriesEmpowerMe } from "../../hooks/useCategories";
import Category from "../../interfaces/models/Category";
import useImageUpload from "../../hooks/useImageUpload";
import { executeDeleteImage } from "../../graphql/queries/getImageUploadURL";
import ImageUploadInput from "../../components/ContentManagement/ImageUploadInput";

//#region Interfaces
interface FilterParams {
    search : string;
}

interface FilterEmParams {
    search : string;
    category : string;
}

interface ModalLabels {
    buttonName : string;
    name : string;
    action : string;
}
//#endregion Interfaces

const EmpowerMeBundleEditorPage = () => {
    //#region Initialization
    const breadcrumbsData = [
        { name: "Content List", path: `${DASHBOARD_ROOT}/content-management/` },
        { name: "Edit Empower ME Bundles", path: `${DASHBOARD_ROOT}/content-management/empower-me/bundles` },
    ];

    const [empowerMeBundles, setEmpowerMeBundles] = useState<EmpowerMeBundle[]>([]);
    const [empowerMeBundlesFiltered, setEmpowerMeBundlesFiltered] = useState<EmpowerMeBundle[]>([]);
    const [empowerMeItems, setEmpowerMeItems] = useState<EmpowerTask[]>([]);
    const [empowerMeItemsFiltered, setEmpowerMeItemsFiltered] = useState<EmpowerTask[]>([]);
    const [empowerMeBundleCategories, setEmpowerMeBundleCategories] = useState<EmpowerMeBundleCategory[]>([]);
    const [empowerMeBundleCategoriesSub, setEmpowerMeBundleCategoriesSub] = useState<EmpowerMeBundleCategory[]>([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalCategoryOpen, setIsModalCategoryOpen] = useState(false);
    const [modalLabels, setModalLabels] = useState<ModalLabels>({
        buttonName: "Save",
        name: "Add New Empower Me Bundle",
        action: "add",
    });
    const [modalLabelsCategory, setModalLabelsCategory] = useState<ModalLabels>({
        buttonName: "Save",
        name: "Add New Bundle Category",
        action: "add",
    });

    const formikRef = useRef<FormikProps<EmpowerMeBundle>>(null);
    const formikRefCategory = useRef<FormikProps<EmpowerMeBundleCategory>>(null);
    const [isOnProcess, setIsOnProcess] = useState<boolean>(false);
    const [initialValue, setInitialValue] = useState<EmpowerMeBundle>(null);
    const [initialValueCategory, setInitialValueCategory] = useState<EmpowerMeBundleCategory>(null);
    const [toBeUpdated, setToBeUpdated] = useState<EmpowerMeBundle>(null);
    const [toBeUpdatedCategory, setToBeUpdatedCategory] = useState<EmpowerMeBundleCategory>(null);
    const [selectedEmNudges, setSelectedEmNudges] = useState<EmpowerTask[]>([]);
    const [categories, setCategories] = useState<Category[]>([]);
    const [subCategories, setSubCategories] = useState<Category[]>([]);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
    const [isDeleteCategoryModalOpen, setIsDeleteCategoryModalOpen] = useState<boolean>(false);
    
    const [filters, setFilters] = useState<FilterParams>({
        search: "",
    });
    const [filtersEm, setFiltersEm] = useState<FilterEmParams>({
        search: "",
        category : "",
    });
    
    const [blobFile, setBlobFile] = useState<File>(null);
    const [url, setUrl] = useState<string>("");
    const [fileId, setFileId] = useState<string>("");
    const imageInputRef = useRef<{ clearImageField: () => void, refetchUrl : () => void }>(null);

    const { loading, error, data } = useEmpowerMeBundlesWithDetails();
    const { loading : categoryLoading, error : categoryError, data : categoryData } = useEmpowerMeBundlesCategories();
    const { data : categData, loading : categLoading} = useCategoriesEmpowerMe();

    const { loading : emLoading, error : emError } = useQuery(getEmpowerMeTasksActive, {
        onCompleted(data) {
            setEmpowerMeItems(data.empower_me_tasks_active);
            setEmpowerMeItemsFiltered(data.empower_me_tasks_active);
        },
        onError(error) {
            console.log(error);
        },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true, // Useful for invoking `onCompleted` during `refetch` calls
    });
    
    const [addEmpowerMeBundleHook] = useMutation(addEmpowerMeBundle,{
        onCompleted : () =>{
            toast.success("Bundle was successfully Added");
        },
        onError : () =>{
            toast.error("Something went wrong whilst adding Bundle details. Please try again or if issue persists, please contact us");
        }
    });

    const [updateEmpowerMeBundleHook] = useMutation(updateEmpowerMeBundle,{
        onCompleted : () =>{
            toast.success("Bundle was successfully Updated");
        },
        onError : () =>{
            toast.error("Something went wrong whilst updating Bundle details. Please try again or if issue persists, please contact us");
        }
    });

    const [removeEmpowerMeBundleHook] = useMutation(removeEmpowerMeBundle,{
        onCompleted : () =>{
            toast.success("Bundle was successfully Deleted");
        },
        onError : () =>{
            toast.error("Something went wrong whilst Deleting Bundle. Please try again or if issue persists, please contact us");
        }
    });

    const [addEmpowerMeBundleCategoryHook] = useMutation(addEmpowerMeBundleCategory,{
        onCompleted : () =>{
            toast.success("Bundle Category was successfully Added");
        },
        onError : () =>{
            toast.error("Something went wrong whilst adding Bundle Category details. Please try again or if issue persists, please contact us");
        }
    });

    const [updateEmpowerMeBundleCategoryHook] = useMutation(updateEmpowerMeBundleCategory,{
        onCompleted : () =>{
            toast.success("Bundle Category was successfully Updated");
        },
        onError : () =>{
            toast.error("Something went wrong whilst updating Bundle Category details. Please try again or if issue persists, please contact us");
        }
    });

    const [removeEmpowerMeBundleCategoryHook] = useMutation(removeEmpowerMeBundleCategory,{
        onCompleted : () =>{
            toast.success("Bundle Category was successfully Deleted");
        },
        onError : () =>{
            toast.error("Something went wrong whilst Deleting Bundle Category. Please try again or if issue persists, please contact us");
        }
    });
    
    const { uploadImage } = useImageUpload();
    const [deleteFile] = useMutation(executeDeleteImage);

    const DeleteFileExecute = async (fileIdCloud : string) => {
        if(!fileIdCloud){
            return; 
        }
        try{
            await deleteFile({
                variables : {
                    fileId : fileIdCloud
                },
            })
        }
        catch(err){
            console.log(err);
        }
    }

    const HandleImageChange = (url : string, fileId : string, blob : File) => {
        setUrl(url);
        setFileId(fileId);
        setBlobFile(blob);
    }

    const IsFetchingToggle = (isGetting : boolean) =>{
        setIsOnProcess(isGetting);
    }


    const HandleFilter = (search : string) => {
        search = search.toLowerCase();
        setEmpowerMeBundlesFiltered(empowerMeBundles.filter((bundle) => {
            return bundle.name.toLowerCase().includes(search) || bundle.description.toLowerCase().includes(search)
        }));
    }

    const HandleSearch = (search : string) => {
        HandleFilter(search);
    }

    
    const HandleEmFilter = (search : string, category : string) => {
        search = search.toLowerCase();
        setEmpowerMeItemsFiltered(empowerMeItems.filter((item) => {
            return (
                (search === "" || (item.name.toLowerCase().includes(search) || item.description.toLowerCase().includes(search)) )
                && (category === "" || item.task_category._id === category)
            )
        }));
    }

    const HandleCategoryChange = (category : string) => {
        setFiltersEm((prev) => ({...prev, category : category}));
        HandleEmFilter(filtersEm.search, category);
    }

    const HandleEmSearch = (search : string) => {
        HandleEmFilter(search, filtersEm.category);
    }

    const HandleSelectEmNudge : (selectedNudge : EmpowerTask, isRemove : boolean) => EmpowerTask[] = (selectedNudge : EmpowerTask, isRemove : boolean) => { 

        let returnData = [];

        setSelectedEmNudges((prev) => {
            const getIndex = prev.findIndex((item) => item._id === selectedNudge._id);
            if (getIndex !== -1) {
                // Remove the item immutably
                returnData =  [...prev.slice(0, getIndex), ...prev.slice(getIndex + 1)];
            } else {
                // Add the item
                returnData =  [...prev, selectedNudge];
            }

            return returnData;
        });

        return returnData;
    }

    const ToggleModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    const ToggleCategoryModal = () => {
        setIsModalCategoryOpen(!isModalCategoryOpen);
    }

    const Reloader = () => {
        setTimeout(() => {
            window.location.reload();
        },700);
    }

    const CategoryRowRender = (item : EmpowerMeBundleCategory, haveChild : boolean) => {

        let rowStyle = "font-weight-bold";
        let spacing = "";

        if(item.level === 1) // Main Category
        {
            rowStyle = "bg-lighter font-weight-bold"
        }
        else if(item.level === 2) {
            spacing = "ps-4"
        }

        return (
            <tr  className={rowStyle}>
                <td >
                    <div> {item.name}</div>
                </td>
                <td className={spacing} >
                    <div>{item.description}</div>
                </td>
                <td>
                    {
                        item.status ? 
                        <Badge color="success">Active</Badge>
                        : <Badge color="secondary" className="text-dark ">Inactive</Badge>
                    }
                </td>
                <td>
                    <Button color="primary" size="sm" disabled={emLoading} onClick={() => HandleOpenCategoryEdit(item)}>Edit</Button>
                    {
                        item.level === 1 &&
                        <Button size="sm" disabled={emLoading === true && !emError && categoryLoading} color="primary" onClick={() => HandleOpenCategoryAdd(item)}>Add Sub Category</Button>
                    }
                    {
                        item.level === 2 &&
                        <Button size="sm" disabled={emLoading === true && !emError && categoryLoading} color="primary" onClick={() => HandleOpenAdd(item)}>Add Bundle</Button>
                    }
                    {
                        haveChild === false && 
                        <Button color="danger" size="sm" onClick={() => HandleOpenCategoryDelete(item)} className="ml-2">Delete</Button>
                    }
                    
                </td>
            </tr>
        )
    }

    useEffect(() => {
        if(categoryData) {
            const empowerMeCategs : EmpowerMeBundleCategory[] = categoryData.empower_me_bundle_categories;
            let main : EmpowerMeBundleCategory[] = [];
            let sub : EmpowerMeBundleCategory[] = [];
            for(let x = 0; x < empowerMeCategs.length; x++) {
                const getCateg = empowerMeCategs[x];

                if(getCateg.level === 1) {
                    main.push(getCateg);
                }
                else if(getCateg.level === 2) {
                    sub.push(getCateg);
                }
            }
            setEmpowerMeBundleCategories(main);
            setEmpowerMeBundleCategoriesSub(sub);
        }
    }, [categoryData]);

      useEffect(() => {
        if(categData) {
            const categRaw : Category[] = categData.categories_empower_me; 
            let mainCategs = [];
            let subCategs = [];
            for(let x = 0; x < categRaw.length; x++) {
              const categ = categRaw[x];
    
              if(categ.level === 2) {
                mainCategs.push(categ);
              }
              else {
                subCategs.push(categ);
              }
            }
            setCategories(mainCategs);
            setSubCategories(subCategs);
        }
    }, [categData]);

    useEffect(() => {
        if(data) {
            setEmpowerMeBundles(data.empower_me_bundles);
            setEmpowerMeBundlesFiltered(data.empower_me_bundles);
        }
    }, [data]);

    

    //#endregion Initialization

    //#region Add And Edit Functions
    const HandleOpenAdd = (category : EmpowerMeBundleCategory) => {
        HandleEmFilter("", "");
        setModalLabels({
            buttonName: "Save",
            name: "Add New Empower Me Bundle",
            action: "add",
        });
        setInitialValue({
            _id : "",
            name : "",
            description : "",
            tasks : [],
            status : true,
            bundle_category_id : category._id,
            status_raw : "true",
            tasks_raw : [],
        });
        setIsModalOpen(true);
        setToBeUpdated(null);
        setSelectedEmNudges([]);
    }
    const HandleOpenEdit = (item : EmpowerMeBundle) => { 
        HandleEmFilter("", "");
        setModalLabels({
            buttonName: "Edit",
            name: "Edit Empower Me Bundle",
            action: "edit",
        });
        setIsModalOpen(true);
        const selectedTask = item.tasks.map((task) => task.empower_me_task_id);
        const editValue = {
            ...item,
            tasks_raw : selectedTask,
            status : item.status,
            status_raw : item.status ? "true" : "false",
        }
        setSelectedEmNudges(empowerMeItems.filter((item) => selectedTask.includes(item._id)));
        setInitialValue(editValue);
        setToBeUpdated(editValue);
    }

    const HandleSubmit = async (formData : EmpowerMeBundle) => {

        if(isOnProcess) return;

        setIsOnProcess(true);

        let isSuccess : boolean = false; 

        if(modalLabels.action === "add") {
            isSuccess = await addEmpowerMeBundleHook({
                variables : {
                    record : {
                        name : formData.name,
                        description : formData.description,
                        status : true,
                        bundle_category_id : formData.bundle_category_id  === "" ? null : formData.bundle_category_id,
                        tasks : formData.tasks_raw.map((item) => {
                            return {
                                empower_me_task_id : item
                            }
                        }),
                    }
                }
            }).then((res) => res.errors ? false : true).catch(()=>false);
        }
        else if(modalLabels.action === "edit") {
            isSuccess = await updateEmpowerMeBundleHook({
                variables : {
                    _id : toBeUpdated._id,
                    record : {
                        name : formData.name,
                        description : formData.description,
                        status : formData.status_raw === "true",
                        bundle_category_id : formData.bundle_category_id  === "" ? null : formData.bundle_category_id,
                        tasks : formData.tasks_raw.map((item) => {
                            return {
                                empower_me_task_id : item
                            }
                        }),
                    }
                }
            }).then((res) => res.errors ? false : true).catch(()=>false);
        }

        if(!isSuccess) {
            setIsOnProcess(false);
            return;
        }

        Reloader();
    }
    //#endregion Add and Edit Functions

    //#region Delete Functions
    const HandleOpenDelete = (item : EmpowerMeBundle) => { 
        setToBeUpdated(item);
        setIsDeleteModalOpen(true);
    }

    const HandleDelete = async () => {
        if(isOnProcess) return;

        setIsOnProcess(true);
        const isSuccess = await removeEmpowerMeBundleHook({
            variables : {
                _id : toBeUpdated._id,
            }
        }).then((res) => res.errors ? false : true).catch(()=>false);

        if(!isSuccess) {
            setIsOnProcess(false);
            return;
        }

        Reloader(); 
    }
    //#endregion Delete Functions

    //#region Category Add and Update Functions
    const HandleOpenCategoryAdd = (item : EmpowerMeBundleCategory | null) => {
        setModalLabelsCategory({
            buttonName: "Save",
            name: "Add Bundle Category",
            action: "add",
        });
        if(item) {
            setInitialValueCategory({
                _id : "",
                name : "",
                description : "",
                status : true,
                status_raw : "true",
                level : item.level + 1,
                image_id : "",
                image_raw : "",
                parent_id : item._id
            });
        }
        else {
            setInitialValueCategory({
                _id : "",
                name : "",
                description : "",
                status : true,
                status_raw : "true",
                image_id : "",
                image_raw : "",
                level : 1
            });
        }
        setIsModalCategoryOpen(true);
        setToBeUpdatedCategory(null);
    }

    const HandleOpenCategoryEdit = (item : EmpowerMeBundleCategory) => { 
        setModalLabelsCategory({
            buttonName: "Edit",
            name: "Edit Bundle Category",
            action: "edit",
        });
        imageInputRef.current?.clearImageField();
        const initialEditedValue : EmpowerMeBundleCategory = {
            _id : item._id,
            name : item.name,
            description : item.description,
            status : item.status,
            status_raw : item.status ? "true" : "false",
            level : item.level,
            image_id : item.image_id,
            image_raw : item.image_id ? "image.png" : ""
        }
        setInitialValueCategory(initialEditedValue);
        setIsModalCategoryOpen(true);
        setToBeUpdatedCategory(initialEditedValue);
    }

    const HandleCategorySubmit = async (formData : EmpowerMeBundleCategory) => {


        if(isOnProcess) return;

        setIsOnProcess(true);

        let isSuccess : boolean = false; 

        if(blobFile){
            const isUploaded = await uploadImage(url,blobFile);
            if(!isUploaded){
                toast.error("Something went wrong whilst uploading your image. Please try again or if issue persists, please contact us");
                setIsOnProcess(false);    
                return;
            }
        }

        if(modalLabelsCategory.action === "add") {
            isSuccess = await addEmpowerMeBundleCategoryHook({
                variables : {
                    record : {
                        name : formData.name,
                        description : formData.description,
                        status : true,
                        level : formData.level,
                        parent_id : formData.parent_id,
                        image_id : formData.level === 1 ? fileId : null
                    }
                }
            }).then((res) => res.errors ? false : true).catch(()=>false);
        }
        else if(modalLabelsCategory.action === "edit") {
            isSuccess = await updateEmpowerMeBundleCategoryHook({
                variables : {
                    _id : toBeUpdatedCategory._id,
                    record : {
                        name : formData.name,
                        description : formData.description,
                        status : formData.status_raw === "true",
                        image_id : formData.level === 1 ? (fileId ?? formData.image_id) : null
                    }
                }
            }).then((res) => res.errors ? false : true).catch(()=>false);
        }

        if(!isSuccess) {
            setIsOnProcess(false);

            if(modalLabelsCategory.action === "edit" && fileId) {
                await DeleteFileExecute(fileId);
                imageInputRef?.current.refetchUrl();
            }

            return;
        }

        if(modalLabelsCategory.action === "edit" && fileId && formData.image_id) {
            await DeleteFileExecute(formData.image_id);
        }

        Reloader();
    }
    //#endregion Category Add and Update Functions
    //#region Category Delete Functions
    const HandleOpenCategoryDelete = (item : EmpowerMeBundleCategory) => { 
        setToBeUpdatedCategory(item);
        setIsDeleteCategoryModalOpen(true);
    }

    const HandleCategoryDelete = async () => {
        if(isOnProcess) return;

        setIsOnProcess(true);
        const isSuccess = await removeEmpowerMeBundleCategoryHook({
            variables : {
                _id : toBeUpdatedCategory._id,
            }
        }).then((res) => res.errors ? false : true).catch(()=>false);

        if(!isSuccess) {
            setIsOnProcess(false);
            return;
        }

        await DeleteFileExecute(toBeUpdatedCategory.image_id);

        Reloader(); 
    }
    //#endregion Category Delete Functions
    
    return (
        <>
            <Breadcrumbs 
                crumbs={breadcrumbsData}
            />
            <Row>
                <Col md={8} className="">
                    <FormGroup className="d-flex align-items-center">
                        <Label className="mr-2">Search: </Label>
                        <Input type="text" placeholder="Search Bundle Name/Description Here" 
                        value={filters.search} 
                        onChange={(e)=> { setFilters((prev) => ({...prev, search : e.target.value}))}} 
                        onKeyUp={(e) => { HandleSearch(e.currentTarget.value)}} />
                    </FormGroup>
                </Col>
                <Col md={4} className="d-flex justify-content-end">
                    <div >
                        <Button color="primary" className="mr-2" onClick={() => { HandleOpenCategoryAdd(null) }}>Add Main Category</Button>
                    </div>
                </Col>

            </Row>
            {
                error && <Alert color="warning" >Sorry! Error on getting Bundles</Alert>
            }
            {
                categoryError && <Alert color="warning" >Sorry! Error on getting Bundle Category</Alert>
            }
            <div className="table-responsive">
                <Table bordered className="bg-white">
                    <thead>
                        <tr>
                            <th>Bundle Name</th>
                            <th>Bundle Description</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            (categoryLoading === true || loading === true) && <tr><td colSpan={4}><Loading /></td></tr> 
                        }
                        {
                            empowerMeBundleCategories.map((item, index) => {



                                const empowerMeSubCategories = empowerMeBundleCategoriesSub.filter(u => u.parent_id === item._id);

                                return (
                                    <React.Fragment key={index}>
                                        {
                                            CategoryRowRender(item, empowerMeSubCategories.length !== 0)
                                        }
                                        {
                                            empowerMeSubCategories.length === 0
                                            && <tr><td colSpan={4} className="text-center">No Sub Categories Found</td></tr>
                                        }
                                        {
                                            empowerMeSubCategories.map((sub, subIndex) => {

                                                const filtered = empowerMeBundlesFiltered.filter(u => u.bundle_category_id === sub._id);
                                                return (
                                                    <React.Fragment key={subIndex}>
                                                        {
                                                            CategoryRowRender(sub, filtered.length !== 0)
                                                        }
                                                        {
                                                            filtered.map((bundle, indexBundlex) => (
                                                                <tr key={indexBundlex}>
                                                                    <td>
                                                                        <div className="pl-4"><i className="fas fa-level-up-alt fa-rotate-90"></i> {bundle.name}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div>{bundle.description}</div>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            bundle.status ? 
                                                                            <Badge color="success">Active</Badge>
                                                                            : <Badge color="secondary" className="text-dark ">Inactive</Badge>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <Button color="primary" size="sm" disabled={emLoading} onClick={() => HandleOpenEdit(bundle)}>Edit</Button>
                                                                        <Button color="danger" size="sm" onClick={() => HandleOpenDelete(bundle)} className="ml-2">Delete</Button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </React.Fragment>
                                                )
                                            })
                                        }
                                        {/* {
                                            loading === false && filtered.length === 0 
                                            && <tr><td colSpan={4} className="text-center">No Bundles on Category Found</td></tr>
                                        } */}
                                    </React.Fragment>
                                )
                            }
                            )
                        }
                    </tbody>
                </Table>
            </div>

            <Modal
                id="empowerme-bundle-category-edit-modal"
                backdrop={true}
                isOpen={isModalCategoryOpen}>
                <ModalHeader toggle={ToggleCategoryModal} className="pb-0">
                    <p className="text-lg">{modalLabelsCategory.name}</p>
                </ModalHeader>
                <ModalBody>
                    <Formik
                        innerRef={formikRefCategory}
                        initialValues={initialValueCategory}
                        validationSchema={AddEmpowerMeBundleCategoryValidator}
                        onSubmit={async (value : EmpowerMeBundleCategory) =>{
                            await HandleCategorySubmit(value);
                        }}
                    >
                        {
                            ({errors, touched, values}) => (
                                <Form>
                                    <TextFormInput
                                        name={"name"}
                                        placeholder="Enter Name"
                                        label="Name"
                                        required={true}
                                        className="mb-0"
                                    />
                                    <div className="form-group mb-0">
                                        <label>Description *</label>
                                        <Field
                                            className="form-control"
                                            name="description"
                                            as="textarea"
                                        />
                                        <FormError>{touched.description && (errors.description)}</FormError>
                                    </div>
                                    <FormGroup className="mb-0">
                                        <Label className="mr-2">Status * </Label>
                                        <Field 
                                            className="form-control" 
                                            as="select" 
                                            name="status_raw"
                                            disabled={modalLabelsCategory.action === "add"}
                                        >
                                            <option value="true">Active</option>
                                            <option value="false">Inactive</option>
                                        </Field>
                                        <FormError>{(errors.status_raw)}</FormError>
                                    </FormGroup>
                                    {
                                        values.level === 1 &&
                                        <>
                                            <ImageUploadInput
                                                ref={imageInputRef}
                                                formikRef={formikRefCategory}
                                                transferFunction={HandleImageChange}
                                                isGettingUrl={IsFetchingToggle}
                                                imageName="image_raw"
                                                imageIdName="image_id"
                                            />
                                        </>
                                    }
                                </Form>
                                
                            )
                        }
                    </Formik>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" disabled={isOnProcess} onClick={ToggleCategoryModal} >Close </Button>
                    <Button color="primary" disabled={isOnProcess} onClick={() => { formikRefCategory?.current.submitForm() }} >{modalLabelsCategory.buttonName}</Button>
                </ModalFooter>
            </Modal>

            <Modal
                id="empowerme-bundle-edit-modal"
                className="modal-xl"
                backdrop={true}
                isOpen={isModalOpen}>
                <ModalHeader toggle={ToggleModal} className="pb-0">
                    <p className="text-lg">{modalLabels.name}</p>
                </ModalHeader>
                <ModalBody>
                    <Formik
                        innerRef={formikRef}
                        initialValues={initialValue}
                        validationSchema={AddEmpowerMeBundleValidator}
                        onSubmit={async (value : EmpowerMeBundle) =>{
                            await HandleSubmit(value);
                        }}
                    >
                        {
                            ({errors, touched, setFieldValue}) => (
                                <Form>
                                    <Row>
                                        <Col md={6}>
                                            <TextFormInput
                                                name={"name"}
                                                placeholder="Enter Name"
                                                label="Name"
                                                required={true}
                                                className="mb-0"
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group mb-0">
                                                <label>Description *</label>
                                                <Field
                                                    className="form-control"
                                                    name="description"
                                                    as="textarea"
                                                />
                                                <FormError>{touched.description && (errors.description)}</FormError>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label className="mr-2">Status * </Label>
                                                <Field 
                                                    className="form-control" 
                                                    as="select" 
                                                    name="status_raw"
                                                    disabled={modalLabels.action === "add"}
                                                >
                                                    <option value="true">Active</option>
                                                    <option value="false">Inactive</option>
                                                </Field>
                                                <FormError>{touched.status_raw && (errors.status_raw)}</FormError>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label className="mr-2">Category </Label>
                                                <Field 
                                                    className="form-control" 
                                                    as="select" 
                                                    name="bundle_category_id"
                                                >
                                                    {
                                                        empowerMeBundleCategories.map((item, index) => (
                                                            <option value={item._id} key={index}>{item.name}</option>
                                                        ))
                                                    }
                                                </Field>
                                                <FormError>{touched.bundle_category_id && (errors.bundle_category_id)}</FormError>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label className="small">Search: </Label>
                                                <Input type="text" placeholder="Search Empower Me Task Name/Description Here" 
                                                value={filtersEm.search} 
                                                onChange={(e)=> { setFiltersEm((prev) => ({...prev, search : e.target.value}))}} 
                                                onKeyUp={(e) => { HandleEmSearch(e.currentTarget.value)}} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label  className="small">
                                                    Seach EM Nudge Category:
                                                </Label>
                                                <Input
                                                    name="select"
                                                    type="select"
                                                    disabled={categLoading}
                                                    onChange={(e) => HandleCategoryChange(e.currentTarget.value)}
                                                >
                                                    <option value="">All</option>
                                                    {
                                                        categories.map((item, index) => 
                                                            <React.Fragment key={index}>
                                                                <optgroup label={item.description}>
                                                                    {
                                                                        subCategories.filter(u => u.parent_id === item._id).map((subItem, subIndex) => (
                                                                            <option key={subIndex} value={subItem._id}>{subItem.description}</option>
                                                                        ))
                                                                    }
                                                                </optgroup>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        {
                                            selectedEmNudges.map((item, index) => {
                                                return (
                                                    <Col md={4} key={index}>
                                                        
                                                        <Alert color="light" className="position-relative">
                                                            <div>
                                                                <div className="font-weight-bold small">{item.task_category.description}</div>
                                                                <small >{item.name}</small>
                                                            </div>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                className="position-absolute top-0 right-0"
                                                                style={{transform: "translate(30%, -30%)"}}
                                                                onClick={() => { 
                                                                    const newSelectedItems = HandleSelectEmNudge(item, true);
                                                                    setFieldValue("tasks_raw", newSelectedItems.map((item) => item._id));
                                                                }}
                                                            >
                                                                <i className="fas fa-times"></i>
                                                            </Button>
                                                        </Alert>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                    <div>
                                        {
                                            errors.tasks_raw && <FormError>{errors.tasks_raw}</FormError>
                                        }
                                    </div>
                                    <div className="table-responsive" style={{maxHeight:350}}>
                                        <Table striped bordered>
                                            <colgroup>
                                                <col style={{ width: "5%" }} />
                                                <col style={{ width: "95%" }} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>EM Task Name & Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    empowerMeItemsFiltered.length === 0 && <tr><td colSpan={2} className="text-center">No Empower Me Nudges Found</td></tr>
                                                }
                                                {
                                                    empowerMeItemsFiltered.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <Field onClick={() => { HandleSelectEmNudge(item, false) }} className="form-control" type="checkbox" name="tasks_raw" value={item._id} />
                                                            </td>
                                                            <td>
                                                                <div><b>{item.name}</b></div>
                                                                <div>{item.description}</div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </Form>
                            )
                        }
                    </Formik>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" disabled={isOnProcess} onClick={ToggleModal} >Close </Button>
                    <Button color="primary" disabled={isOnProcess || emLoading} onClick={() => { formikRef?.current.submitForm() }} >{modalLabels.buttonName}</Button>
                </ModalFooter>
            </Modal>

            <PromptDialogs
                isOpen={isDeleteModalOpen}
                onCancel={() => { setIsDeleteModalOpen(false); }}
                onConfirm={HandleDelete}
                title="Delete Bundle"
                promptMessage="Are you sure you want to delete this Bundle?"
                confirmBtnTxt="Delete"
                isOnProcess={isOnProcess}
            />

            <PromptDialogs
                isOpen={isDeleteCategoryModalOpen}
                onCancel={() => { setIsDeleteCategoryModalOpen(false); }}
                onConfirm={HandleCategoryDelete}
                title="Delete Category"
                promptMessage="Are you sure you want to delete this Category?"
                confirmBtnTxt="Delete"
                isOnProcess={isOnProcess}
            />

        </>
    )
}

export { EmpowerMeBundleEditorPage as EmpowerMeBundleEditor };